import { BaseService, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { VisitType } from "@kiddocare-platform/portal-common/clinical";
import type { Performance } from "@kiddocare-platform/portal-common/clinical";

export class ClinicalConfigurationService extends BaseService {

  public async GetVisitTypesPediatrician(idAccountPediatrician: bigint): Promise<ResponseMessage<Array<VisitType>>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/configuration/getVisitTypesPediatrician/${idAccountPediatrician}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetVisitTypesPediatrician", error.stack, JSON.stringify(error));
      throw error;
    }
  }

  public async GetPerformancesByPediatrician(idAccountPediatrician: bigint): Promise<ResponseMessage<Array<Performance>>> {
    try {
      const response = await this.AxiosInstance.get(`/parent/configuration/getPerformancesByPediatrician/${idAccountPediatrician}`);
      return response.data;
    } catch (error: any) {
      this.log.error("GetPerformancesByPediatrician", error.stack, JSON.stringify(error));
      throw error;
    }
  }

}
